import { render, staticRenderFns } from "./dueDateResume.vue?vue&type=template&id=54c6f7c4&"
import script from "./dueDateResume.vue?vue&type=script&lang=js&"
export * from "./dueDateResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports